"use client";

import { ListCard, FollowersChange } from "@/components/shared";
import type { PublisherGameWishlist } from "../types";
import { RANK_LIST_CONFIGS } from "@/features/rank-list/shared";

interface PublisherGameWishlistCardsProps {
  games: PublisherGameWishlist[];
  onCardClick: (appid: number) => void;
}

const PRIMARY_COLOR = RANK_LIST_CONFIGS.wishlist.primaryColor;

export function PublisherGameWishlistCards({
  games,
  onCardClick,
}: PublisherGameWishlistCardsProps) {
  return (
    <div className="md:hidden">
      {games.map((game) => (
        <ListCard
          key={game.appid}
          item={game}
          onCardClick={onCardClick}
          renderImage={(game: PublisherGameWishlist) => ({
            src: game.capsule_image || game.header_image,
            alt: game.name,
            width: 120,
            height: 45,
          })}
          renderTitle={(game: PublisherGameWishlist) => game.name}
          renderPrice={() => ({ isFree: null, priceFinal: null })}
          renderPlatforms={() => ({
            supportsWindows: null,
            supportsMac: null,
            supportsLinux: null,
          })}
          renderMetadata={(game: PublisherGameWishlist) => (
            <>
              {game.wishlist_rank && (
                <p className="mb-1">
                  <span className="font-bold text-sm" style={{ color: PRIMARY_COLOR }}>
                    Rank: #{game.wishlist_rank}
                  </span>
                </p>
              )}
              <p className="mb-1">
                <span className="text-[#66c0f4]">ID: {game.appid}</span>
              </p>
              {(game.release_date || game.coming_soon) && (
                <p className="mb-1">
                  Release:{" "}
                  {game.coming_soon ? "Coming Soon" : game.release_date}
                </p>
              )}
            </>
          )}
          renderFooter={(game: PublisherGameWishlist) => (
            <div className="flex items-center justify-between gap-4 mt-2 pt-2 border-t border-[#2a475e]">
              <div className="flex flex-col gap-1">
                <span className="text-xs text-[#8f98a0]">1D</span>
                <FollowersChange value={game.wishlist_rank_1d} />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xs text-[#8f98a0]">7D</span>
                <FollowersChange value={game.wishlist_rank_7d} />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xs text-[#8f98a0]">30D</span>
                <FollowersChange value={game.wishlist_rank_30d} />
              </div>
            </div>
          )}
        />
      ))}
    </div>
  );
}

